
window.addEventListener("load", function () {

//export default swiperLoichuc;
});
